<template>
  <a
    rel="nofollow"
    :href="tagUrl"
    class="article__badge flex items-center justify-center w-9 h-9 sm:w-11 sm:h-11"
    :class="{ 'article__badge--pin absolute transform -translate-x-1 -translate-y-1 sm:-translate-x-4 sm:-translate-y-4': pin }"
    :style="sizeStyle"
    aria-label="etiket"
    :title="title"
  >
    <OImage
      loading="lazy"
      :src="badgeUrl"
      class="article__badge-img w-9 h-9 sm:w-11 sm:h-11"
      :class="{ 'rounded-full': isBadgeGif }"
      :style="{ ...sizeStyle }"
      alt="etiket"
    />
  </a>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { getTagUrl } from '~/modules/common/utils/routingUtils';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OImage },
  props: {
    /**
     * Badge Data
     * @example
     * {
     * _id: "539f74a96aa0675f5b84c009",
     * name: "Roket",
     * icons: {
     *   svg: "https://static.onedio.com/icons/badge/svg/rocket.svg",
     *   png: "https://static.onedio.com/icons/badge/png/rocket.png"
     *   }
     * },
     */
    badge: {
      type: Object,
      default: null,
      required: false,
    },
    /**
     * Badge boyutu
     */
    size: {
      default: null,
      type: String | Number,
    },
    /**
     * sol üst köşeye pinler
     */
    pin: {
      default: false,
      type: Boolean,
    },
    /**
     * Badge boyutu
     */
    title: {
      default: '',
      type: String,
    },
  },
  setup(props) {
    const isBadgeGif = computed(() => props.badge?.icons?.gif);
    const badgeUrl = computed(() => props.badge?.icons?.gif || props.badge?.icons?.svg || props.badge?.icons?.png);
    const sizeStyle = computed(() => {
      if (!props.size) return {};
      return {
        width: props.size + 'px',
        height: props.size + 'px',
      };
    });
    const tagUrl = computed(() => getTagUrl({ tag: props.badge }));
    return {
      isBadgeGif,
      badgeUrl,
      sizeStyle,
      tagUrl,
    };
  },
});
</script>

<style>
.article__badge {
  border-radius: 50%;
  background: #ffe400;
  line-height: 14px;
}
.article__badge--pin {
  position: absolute !important;
}
.article__badge-img {
  background-size: contain;
  background-repeat: no-repeat;
  display: block;
  padding: 0;
}
</style>
